import { IrisGlobalSettingsI } from '@iris/common/models/IrisGlobalSettings';
import { IrisQueryParamsOrderBy } from '@iris/api-query';
import { IrisCompanyI } from '@iris/common/models/IrisCompany';
import { IrisCountryI } from '@iris/common/models/IrisCountry';
import { IrisUserColumnSettingsI } from '@iris/common/modules/grid-configuration/models/grid-configuration.settings';

export interface IrisDmsSettingsPropertyI {
  id?: string;
  name: string;
  title?: string;
  model?: string;
  backField?: string;
  searchField?: string;
  showIcons?: string;
  isForFiles?: boolean;
  isForFolders?: boolean;
  isActive: boolean;
  isMultiple: boolean;
  directory?: (IrisCompanyI & IrisCountryI)[];
  value?: string[] | string;
}

export interface IrisDmsSettingsPropertyMetaI {
  name: string;
  directory$: Function;
  model: string;
  isForFiles: boolean;
  isForFolders: boolean;
  backField?: string;
  searchField?: string;
  showIcons?: string;
}

export interface IrisDmsSettingsResponseI extends IrisGlobalSettingsI<IrisDmsSettingsI> {
  value: IrisDmsSettingsI;
}

export interface IrisDmsSettingsI {
  workflowId: string;
  active4Users: boolean;
  dustbinDays: number;
  maxFileSizeNonAdmin: number;
  maxFileSizeAdmin: number;
  userGroupsEnabled: boolean;
  enableFileDescription: boolean;
  properties: IrisDmsSettingsPropertyI[];
}

export interface IrisDmsUserSettingsResponseI {
  createdBy?: number;
  createdOn?: Date;
  id?: number;
  module?: string;
  settings: IrisDmsUserSettingsI;
  actions: IrisDmsUserActionStateI;
  updatedBy?: number;
  updatedOn?: Date;
  userId?: number;
}

export interface IrisDmsUserSettingsI {
  columns: IrisUserColumnSettingsI[];
  enableDmsExperimentalFeatures: boolean;
  orderBy: IrisQueryParamsOrderBy[];
}

export interface IrisDmsUserActionStateI {
  [name: string]: boolean;
}
export enum IrisDmsSettingsAlias {
  Folder = 'dms-grid-config-vmodal5',
  Trash = 'dms-trash',
  SystemTrash = 'dms-system-trash',
  Filter = 'dms-smart-folders-grid-config',
  SystemFolder = 'dms-system-folder',
  Api = 'dms-api',
  RecentFiles = 'dms-recent-files-folder',
}

